import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CommunicationTemplatesDefaultsDTO } from 'src/app/core/models/system/communication/communication-templates-defaults.dto';
import { CompletedModalFormComponent } from '../_pop-ups/completed-modal-form/completed-modal-form.component';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DeliveryType, TemplateModalAction } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { InputModalFormComponent } from 'src/app/forms-modal/_inputs/input-form/input-modal-form.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';

@Component({
  selector: 'app-template-sms-modal-form',
  templateUrl: './template-sms-modal-form.component.html',
  styleUrls: ['./template-sms-modal-form.component.scss']
})
export class TemplateSMSModalFormComponent {
  public formTitle = 'SMS Template';

  @Input() bodyOnly                      : boolean | undefined;
  @Input() embeddedFormMode              : boolean | undefined;
  @Input() title                         : string  | undefined;
  @Input() updateMessage                 : string  | undefined;

  @Output() companyDefaultsUpdated       : EventEmitter<void> = new EventEmitter<void>();
  @Output() smsTemplateModalFormClosed   : EventEmitter<{TemplateModalAction : TemplateModalAction,TemplateId : number}> = new EventEmitter<{TemplateModalAction : TemplateModalAction,TemplateId : number}>();
  
  @ViewChild('completedModalForm',      { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('inputModalForm',          { static: false }) inputModalForm!    : InputModalFormComponent;
  @ViewChild('templateModalForm',       { static: false }) templateModalForm! : TemplateRef<void>;

  get canEditTemplate() { return this.authenticationService.canEditSystemOwned(this.template?.systemOwned ?? false); }
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false);      }
  get hideFromOptions() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.CommunicationTemplatesHideFromOptions, true ); }

  private curUser                     : SystemUserDTO;
  private selectedTemplateReplacement!: CommunicationTemplateReplacements;
  private sureSimCompanyId            : number | undefined;
  private templateModalFormRef!       : NgbModalRef;

  public alreadyEnabled               : boolean = false;
  public companyDefaults!             : CommunicationTemplatesDefaultsDTO;
  public hideMessageType              : boolean = false;
  public hideSaveAndEnable            : boolean = false;
  public lastMouseEvent               : MouseEvent | undefined;
  public lastSystemValueTarget        : HTMLInputElement | HTMLTextAreaElement | undefined;
  public messageType                  : string = '';
  public onlyShowBody                 : boolean = false;
  public saveAllocation               : boolean = false;
  public selectedTemplateReplacementId: number = 0;
  public showElsewhereMessage         : boolean = false;
  public template!                    : CommunicationTemplateDTO;
  public templateFormSubmitted        : boolean = false;
  public templateForm!                : UntypedFormGroup;
  public templateModalAction          : TemplateModalAction = TemplateModalAction.Cancel;
  public templateReplacements         : CommunicationTemplateReplacements[] = [];
  public templateReplacementsValues   : {name:string, id:number}[] = [];
  
  constructor(
    private authenticationService: AuthenticationService,
    private commConfigService    : CommConfigService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private modalService         : NgbModal
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnDestroy() {
    this.closeForm(this.templateModalAction);
  }

  public closeForm(templateModalAction: TemplateModalAction): void {
    try {
      this.smsTemplateModalFormClosed.emit({TemplateModalAction:templateModalAction, TemplateId:this.template?.id ?? -1});
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formData() {
    return this.templateForm.controls;
  }

  public openForm(messageType: string, template: CommunicationTemplateDTO, companyId: number, templateReplacements: CommunicationTemplateReplacements[], companyDefaults: CommunicationTemplatesDefaultsDTO,
                  alreadyEnabled: boolean, saveAllocation: boolean = true, hideMessageType: boolean = false, hideSaveAndEnable: boolean = false, onlyShowBody: boolean = false): void {
    try {
      this.alreadyEnabled             = alreadyEnabled;
      this.companyDefaults            = companyDefaults;
      this.hideMessageType            = hideMessageType;
      this.hideSaveAndEnable          = hideSaveAndEnable;
      this.messageType                = messageType;
      this.onlyShowBody               = onlyShowBody;
      this.saveAllocation             = saveAllocation;
      this.showElsewhereMessage       = template.sendElsewhere ?? false;
      this.sureSimCompanyId           = companyId;
      this.template                   = template;
      this.templateFormSubmitted      = false;
      this.templateModalAction        = TemplateModalAction.Cancel;
      this.templateReplacements       = templateReplacements;
      this.templateReplacementsValues = this.templateReplacements.map(item => ({  name: item.columnName ?? "", id: item.id }))
      this.openModal();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.templateForm);
      this.templateForm = this.formBuilder.group({ });
      this.addFormFields(this.templateForm);

      this.populateFormFields();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDefaultFromNumberChange(event: Event)
  {
    try {
      const isChecked = (event.target as HTMLInputElement).checked;
      if(isChecked){
        this.templateForm.controls["fromNumber"].setValue('');
        this.templateForm.controls['fromNumber']?.disable();
      } else{
        this.templateForm.controls['fromNumber']?.enable();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDefaultToNumberChange(): void {
    try {
      if(this.formData['useDefaultToNumber'].value) {
        this.templateForm.controls["toNumber"].setValue('');
        this.templateForm.get('toNumber')?.disable({ emitEvent: false });
      } else{
        this.templateForm.get('toNumber')?.enable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onSendElsewhereChange(): void {
    try {
      this.showElsewhereMessage = this.formData['sendElsewhere'].value;
      if(this.formData['sendElsewhere'].value){
        this.templateForm.get('useDefaultToNumber')?.enable({ emitEvent: false });
        if(this.formData['useDefaultToNumber'].value) {
            this.templateForm.get('toNumber')?.disable({ emitEvent: false });
          } else{
            this.templateForm.get('toNumber')?.enable({ emitEvent: false });
          }
      } else{
        this.templateForm.controls["toNumber"].setValue('');
        this.templateForm.controls["useDefaultToNumber"].setValue(false);
        this.templateForm.get('toNumber')?.disable({ emitEvent: false });
        this.templateForm.get('useDefaultToNumber')?.disable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onSendToUserChange(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private populateFormFields() {
    try {
      if (this.templateForm != undefined) {
        this.templateForm.controls["fromNumber"].setValue(this.template.fromNumber);
        this.templateForm.controls["message"].setValue(this.template.body);
        this.templateForm.controls["templateName"].setValue(this.template.name);
        this.templateForm.controls["useDefaultFromNumber"].setValue(this.template.useDefaultFromNumber || this.hideFromOptions);
        this.templateForm.controls["useDefaultToNumber"].setValue(this.template.useDefaultToNumber ?? false); 
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private reflectChanges() {
    try{
      this.template.body = this.formData['message'].value;
      this.template.fromNumber = this.formData['fromNumber'].value;
      this.template.name = this.formData['templateName'].value; 
      this.template.sendElsewhere = this.formData['sendElsewhere'].value;   
      this.template.sendToUser = this.formData['sendToUser'].value;   
      this.template.toNumber = this.formData['toNumber'].value;       
      this.template.useDefaultFromNumber = this.formData['useDefaultFromNumber'].value;
      this.template.useDefaultToNumber = this.formData['useDefaultToNumber'].value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      this.addFormControl(formGroup, "fromNumber",               this.template.fromNumber                ,   []);
      this.addFormControl(formGroup, "message",                  this.template.body                      ,   [Validators.required]);
      this.addFormControl(formGroup, "sendToUser",               this.template.sendToUser ?? false       ,   [Validators.required]);
      this.addFormControl(formGroup, "sendElsewhere",            this.template.sendElsewhere ?? false    ,   [Validators.required]);
      this.addFormControl(formGroup, "templateName",             this.template.name                      ,   [Validators.required]);
      this.addFormControl(formGroup, "toNumber",                 this.template.toNumber ?? ""            ,   []);
      this.addFormControl(formGroup, "useDefaultFromNumber",     this.template.useDefaultFromNumber      ,   [Validators.required]);
      this.addFormControl(formGroup, "useDefaultToNumber",       this.template.useDefaultToNumber ?? ""  ,   [Validators.required]);
      if(this.template.useDefaultFromNumber){
        formGroup.get('fromNumber')?.disable({ emitEvent: false });
      } else{
        formGroup.get('fromNumber')?.enable({ emitEvent: false });
      }

      if(this.template.sendElsewhere) {
        if(this.template.useDefaultToNumber) {
          formGroup.get('toNumber')?.disable({ emitEvent: false });
        } else{
          formGroup.get('toNumber')?.enable({ emitEvent: false });
        }
      } else {
          formGroup.get('toNumber')?.disable({ emitEvent: false });
          formGroup.get('useDefaultToNumber')?.disable({ emitEvent: false });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl( value, validators));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.templateModalFormRef = this.modalService.open(this.templateModalForm, 
        { 
          backdrop: this.modalBackGround, 
          centered: true,
          keyboard: false,
          size    : msSize.Large 
        });
    }
    catch(e) {
      this.smsTemplateModalFormClosed.emit({TemplateModalAction:TemplateModalAction.Cancel, TemplateId:this.template.id});
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public saveAndEnable() {
    try {
      this.reflectChanges();
      let saveBody = {
        AlertTypeId          : this.template.alertTypeId,
        ID                   : this.template.id,
        CompanyId            : this.sureSimCompanyId,
        DeliveryTypeId       : DeliveryType.SMS,
        MessageTypeId        : this.template.messageTypeId,
        Name                 : this.template.name,
        Subject              : this.template.subject,
        Body                 : this.template.body,
        CC                   : this.template.cc,
        BCC                  : this.template.bcc,
        FromEmail            : this.template.fromEmail,
        FromNumber           : this.template.fromNumber,
        SendElsewhere        : this.template.sendElsewhere,
        SendToUser           : this.template.sendToUser,
        ToEmail              : this.template.toEmail,
        ToNumber             : this.template.toNumber,
        UseDefaultCC         : this.template.useDefaultCC,
        UseDefaultBCC        : this.template.useDefaultBCC,
        UseDefaultFromEmail  : this.template.useDefaultFromEmail,
        UseDefaultFromNumber : this.template.useDefaultFromNumber,
        UseDefaultToEmail    : this.template.useDefaultToEmail,
        UseDefaultToNumber   : this.template.useDefaultToNumber,
        EnteredBy            : this.curUser.userId,
        Active               : true,
        Deleted              : false,
        SystemOwned          : false
      };
      let enableBody = {
        TemplateId      : this.template.id,
        CompanyId       : this.sureSimCompanyId,
        DeliveryTypeId  : DeliveryType.SMS,
        MessageTypeId   : this.template.messageTypeId,
        EnteredBy       : this.curUser.userId
      };
      if(this.template.id > 0){
        this.commConfigService.editCommunicationTemplate(saveBody).subscribe(id => {
          if (this.saveAllocation) {
            this.commConfigService.enableCompanyTemplate(enableBody).subscribe(y => {
              this.templateModalAction = TemplateModalAction.SaveAndEnable;
              this.completedModalForm.openForm("Congratulations", this.updateMessage != undefined ? this.updateMessage : "Template has been updated and enabled.");
            });
          } else {
              this.templateModalAction = TemplateModalAction.SaveAndEnable;
              this.completedModalForm.openForm("Congratulations", this.updateMessage != undefined ? this.updateMessage : "Template has been updated and enabled.");
          }
        });
      }
      else{
        this.commConfigService.createCommunicationTemplate(saveBody).subscribe(id => {
          enableBody.TemplateId = id;
          this.template.id      = id;
          if (this.saveAllocation) {
            this.commConfigService.enableCompanyTemplate(enableBody).subscribe(y => {
              this.templateModalAction = TemplateModalAction.SaveAndEnable;
              this.completedModalForm.openForm("Congratulations", this.updateMessage != undefined ? this.updateMessage : "Template has been created and enabled.");
            });
          } else {
            this.templateModalAction = TemplateModalAction.SaveAndEnable;
            this.completedModalForm.openForm("Congratulations", this.updateMessage != undefined ? this.updateMessage : "Template has been created and enabled.");
          }
        })
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public save() {
    try {
        this.reflectChanges();
        let saveBody = {
          AlertTypeId          : this.template.alertTypeId,
          ID                   : this.template.id,
          CompanyId            : this.sureSimCompanyId,
          DeliveryTypeId       : DeliveryType.SMS,
          MessageTypeId        : this.template.messageTypeId,
          Name                 : this.template.name,
          Subject              : this.template.subject,
          Body                 : this.template.body,
          CC                   : this.template.cc,
          BCC                  : this.template.bcc,
          FromEmail            : this.template.fromEmail,
          FromNumber           : this.template.fromNumber,
          SendElsewhere        : this.template.sendElsewhere,
          SendToUser           : this.template.sendToUser,
          ToEmail              : this.template.toEmail,
          ToNumber             : this.template.toNumber,
          UseDefaultCC         : this.template.useDefaultCC,
          UseDefaultBCC        : this.template.useDefaultBCC,
          UseDefaultFromEmail  : this.template.useDefaultFromEmail,
          UseDefaultFromNumber : this.template.useDefaultFromNumber,
          UseDefaultToEmail    : this.template.useDefaultToEmail,
          UseDefaultToNumber   : this.template.useDefaultToNumber,
          EnteredBy            : this.curUser.userId,
          Active               : true,
          Deleted              : false,
          SystemOwned          : false
        };
        if(this.template.id > 0){
          this.commConfigService.editCommunicationTemplate(saveBody).subscribe(x => {
            this.templateModalAction = TemplateModalAction.Save;
            this.completedModalForm.openForm("Congratulations", this.updateMessage != undefined ? this.updateMessage : "Template has been updated.");
          });
        }
        else{
          this.commConfigService.createCommunicationTemplate(saveBody).subscribe(id => {
            this.template.id         = id;
            this.templateModalAction = TemplateModalAction.Save;
            this.completedModalForm.openForm("Congratulations", this.updateMessage != undefined ? this.updateMessage : "Template has been created.");
          });
        } 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    this.closeForm(this.templateModalAction);
    this.templateModalFormRef.close('Close click');
  }
  
  public invalidInputs(): boolean {
    let valid = (this.formData['templateName'].value != null && this.formData['templateName'].value.trim() != '' 
            && this.formData['message'].value != null && this.formData['message'].value.trim() != ''
            && ((this.formData['fromNumber'].value != null && this.formData['fromNumber'].value.trim() != '') || this.formData['useDefaultFromNumber'].value)
          );

    if (valid && this.formData['sendElsewhere'].value) {
      let toNumberValid        = (this.formData['toNumber'].value != null && this.formData['toNumber'].value.trim() != '' && !this.formData['useDefaultToNumber'].value);
      let toNumberDefaultValid = (this.formData['useDefaultToNumber'].value && this.companyDefaults.toNumber != null && this.companyDefaults.toNumber.trim() != '');
      valid = toNumberValid || toNumberDefaultValid;
    }

    if (!this.formData['sendToUser'].value && !this.formData['sendElsewhere'].value) {
      valid = false;
    }

    if (valid) {
      valid = this.getDodgySystemPlaceHolders(this.formData['message'].value) == "";
    }
    return !valid;
  }

  public getDodgySystemPlaceHolders(inputValue:string): string {
    let words: string[] = [];
    let dodgyPlaceHolders: string = "";

    if (inputValue != null) {
      words = inputValue
        .trim()
        .replace(/\,/," ")
        .replace(/@@/g," @@")
        .split(/\s+/); // Splits by one or more spaces
  
      words.forEach(word => {
        if(word.startsWith('@@')) {
          if(!this.templateReplacements.some(p => word.startsWith(p.placeHolder ?? ""))) {
            dodgyPlaceHolders += ',' + word;
          }
        }
      });
  
      if (dodgyPlaceHolders != "") {
        dodgyPlaceHolders = dodgyPlaceHolders.substring(1,10000);
      }

    }

    return dodgyPlaceHolders;
  }

  public saveAsNew() {
    try {
      this.reflectChanges();
      this.commConfigService.createCommunicationTemplate({
        AlertTypeId          : this.template.alertTypeId,
        ID                   : 0,
        CompanyId            : this.sureSimCompanyId,
        DeliveryTypeId       : DeliveryType.SMS,
        MessageTypeId        : this.template.messageTypeId,
        Name                 : this.template.name,
        Subject              : this.template.subject,
        Body                 : this.template.body,
        CC                   : this.template.cc,
        BCC                  : this.template.bcc,
        FromEmail            : this.template.fromEmail,
        FromNumber           : this.template.fromNumber,
        SendElsewhere        : this.template.sendElsewhere,
        SendToUser           : this.template.sendToUser,
        ToEmail              : this.template.toEmail,
        ToNumber             : this.template.toNumber,
        UseDefaultCC         : this.template.useDefaultCC,
        UseDefaultBCC        : this.template.useDefaultBCC,
        UseDefaultFromEmail  : this.template.useDefaultFromEmail,
        UseDefaultFromNumber : this.template.useDefaultFromNumber,
        UseDefaultToEmail    : this.template.useDefaultToEmail,
        UseDefaultToNumber   : this.template.useDefaultToNumber,
        EnteredBy            : this.curUser.userId,
        Active               : true,
        Deleted              : false,
        SystemOwned          : false
      }).subscribe(id => {
        this.template.id         = id;
        this.templateModalAction = TemplateModalAction.Save;
        this.completedModalForm.openForm("Congratulations", this.updateMessage != undefined ? this.updateMessage : "Template has been saved.");
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editFromNumberDefault(): void {
    try {
      this.lastMouseEvent = undefined;

      this.inputModalForm.fieldCaption                    ="Value";
      this.inputModalForm.formTitle                       ="From Number Default";
      this.inputModalForm.input0EnforceEmailValidation    =false;
      this.inputModalForm.input0EnforceMaxLengthValidation=false;
      this.inputModalForm.input0EnforceRequiredValidation =false;
      this.inputModalForm.input0Value                     =this.companyDefaults.fromNumber;
      this.inputModalForm.input0Values                    =undefined;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editSendElsewhereDefault(): void {
    try {
      this.lastMouseEvent = undefined;

      this.inputModalForm.fieldCaption                    ="Value";
      this.inputModalForm.formTitle                       ="Send Elsewhere Default";
      this.inputModalForm.input0EnforceEmailValidation    =false;
      this.inputModalForm.input0EnforceMaxLengthValidation=false;
      this.inputModalForm.input0EnforceRequiredValidation =false;
      this.inputModalForm.input0Value                     =this.companyDefaults.toNumber;
      this.inputModalForm.input0Values                    =undefined;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public inputModalFormSubmitted(inputValue: string) {
    try {
      if (this.inputModalForm.formTitle == "Insert System Value") {
        let selectedSystemValue = this.templateReplacements.find(x => x.id == Number(inputValue));
        if(selectedSystemValue){
          this.insertTextAtCursor(<HTMLTextAreaElement>this.lastSystemValueTarget, selectedSystemValue.placeHolder ?? "");
        }
      } else {
        if (this.inputModalForm.formTitle        == "From Number Default") {
          this.companyDefaults.fromNumber = inputValue;
        } else if (this.inputModalForm.formTitle == "Send Elsewhere Default") {
          this.companyDefaults.toNumber = inputValue;
        }
        this.updateCompanyDefaults();
      } 
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public updateCompanyDefaults(): void {
    try {
      this.commConfigService.createCompanyCommunicationTemplateDefaults({
        BCC       : this.companyDefaults.bcc,
        CC        : this.companyDefaults.cc,
        CompanyId : this.sureSimCompanyId,
        EnteredBy : this.curUser.userId,
        FromEmail : this.companyDefaults.fromEmail,
        FromNumber: this.companyDefaults.fromNumber,
        ToEmail   : this.companyDefaults.toEmail,
        ToNumber  : this.companyDefaults.toNumber,
      })
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.companyDefaultsUpdated.emit();
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });

        this.companyDefaultsUpdated.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public handleMouseClick(event: MouseEvent): void {
    try {
      if (event.ctrlKey) {
        this.lastMouseEvent       =event;
        this.lastSystemValueTarget=<HTMLInputElement | HTMLTextAreaElement>event.target;
        this.openSystemValuePicker();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public handleKeyUp(event: KeyboardEvent): void {
    try {
      const target=<HTMLInputElement | HTMLTextAreaElement>event.target;

      if (!target || (target.tagName != 'INPUT' && target.tagName != 'TEXTAREA'))
        return;

      const caret=target.selectionStart ?? 0;

      if (caret<2 || target.value.substring(caret-2, caret) != '@@')
        return;

      const before=target.value.substring(0, caret-2);
      const after =target.value.substring(caret);

      target.value=before+after;
      target.setSelectionRange(caret-2, caret-2);
      target.dispatchEvent(new Event('input'));

      this.lastMouseEvent       =undefined;
      this.lastSystemValueTarget=target;
      this.openSystemValuePicker();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openSystemValuePicker(): void {
    try {
      this.inputModalForm.fieldCaption                    ="System Value";
      this.inputModalForm.formTitle                       ="Insert System Value";
      this.inputModalForm.input0EnforceEmailValidation    =false;
      this.inputModalForm.input0EnforceMaxLengthValidation=false;
      this.inputModalForm.input0EnforceRequiredValidation =false;
      this.inputModalForm.input0Value                     =undefined;
      this.inputModalForm.input0Values                    =this.templateReplacementsValues;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public insertTextAtCursor(textArea: HTMLTextAreaElement, text: string): void {
    const start = textArea.selectionStart;
    const end = textArea.selectionEnd;
  
    // Insert the text at the cursor position
    const before = textArea.value.substring(0, start);
    const after = textArea.value.substring(end);
    textArea.value = before + text + after;
  
    // Move the cursor to the end of the inserted text
    const cursorPosition = start + text.length;
    textArea.setSelectionRange(cursorPosition, cursorPosition);
  
    // Trigger change detection if needed
    textArea.dispatchEvent(new Event('input'));
  }
}
